import { formatDate } from 'utils/masks'
import { translateBoolean } from 'utils/functions'
import { translatePlanPole } from 'utils/constants/planPoleTypes'

const customCreatedAtRender = (value) => {
  return formatDate(value, { hideHour: true })
}

const customVisibleToOrgRender = (value) => {
  return translateBoolean(value)
}

const customProcessPoleRender = (value) => {
  return translatePlanPole(value)
}

export const columnsPlans = [
  {
    name: 'name',
    label: 'Nome',
  },
  {
    name: 'description',
    label: 'Descrição',
  },
  {
    name: 'process_pole',
    label: 'Polo consultado',
    options: {
      customBodyRender: customProcessPoleRender,
    },
  },
  {
    name: 'user_email',
    label: 'Criado por',
  },
  {
    name: 'created_at',
    label: 'Criado em',
    options: {
      customBodyRender: customCreatedAtRender,
    },
  },
  {
    name: 'visible_to_organization',
    label: 'Compartilhado com a organização',
    options: {
      customBodyRender: customVisibleToOrgRender,
    },
  },
  {
    name: 'action',
    label: 'Ação',
  },
]
